// @flow

import { createSelector } from 'reselect';

import { selectPricingInfos } from '@gandi/billing';
import { useResourcePost } from '@gandi/resource/react';

import type { FetchParams } from '@gandi/resource/redux';

import { useAppSelector } from 'src/hooks/useAppSelector';

import { quotationsResource } from '../../modules/cloud/resources/quotations';
import type { FullState } from '../../types';

export type FetchQuotationsParams = {
  country: string,
  currency: string,
  grid: string,
  sharing_id: string,
  with_contract?: boolean,
};

export const defaultMode = {
  duration_unit: 'd',
  duration: 30,
};

const selectFetchQuotationsParams: (state: FullState) => FetchQuotationsParams =
  // $FlowFixMe[incompatible-call]
  createSelector([selectPricingInfos], pricingInfos => ({
    country: pricingInfos.country,
    currency: pricingInfos.currency,
    duration_unit: 'd',
    duration: 30,
    grid: pricingInfos.grid,
    sharing_id: pricingInfos.sharingId,
    with_contract: true,
  }));

export function useQuotations(): {
  fetchQuotationsParams: FetchQuotationsParams,
  handlePostQuotations: any,
  isPostingQuotations: boolean,
} {
  const fetchQuotationsParams = useAppSelector(selectFetchQuotationsParams);
  const { handlePost: handlePostQuotations, isPosting: isPostingQuotations } =
    useResourcePost(quotationsResource, (fetchQuotationsParams: FetchParams));

  return {
    fetchQuotationsParams,
    handlePostQuotations,
    isPostingQuotations,
  };
}
